import React from 'react';
import Path from '../components/Path';
import ProjectList from '../components/ProjectList';

const Projects = ({ t, locale }) => {
  const projectsData = locale?.projects || {};
  
  return (
    <>
      <Path description={t.description} />
      <ProjectList 
        title={t.decent} 
        filter={(p) => !p.isSmall} 
        t={projectsData}
      />
      <ProjectList 
        title={t.small} 
        filter={(p) => p.isSmall && !p.isInProgress} 
        t={projectsData}
      />
    </>
  );
};

export default Projects;